import { useTranslation } from 'react-i18next';
import { Form, Icon, Page } from '@/components';
import { Button, Space } from 'antd';
import { AdminTabKeys } from '@/views/Admin/AdminTabs';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import {
  UpdateTermsAndConditionsArgs,
  useGetTermsAndConditionsQuery,
  useUpdateTermsAndConditionsMutation,
} from '@/redux/termsAndConditions';
import { TermsAndConditionsEditPanel } from '@/views';
import { useUserContextSelector } from '@/redux';

export function TermsAndConditionsEditPage() {
  const { t } = useTranslation();
  const title = t('termsAndConditions.update');
  const [update] = useUpdateTermsAndConditionsMutation();
  const organizationId = useUserContextSelector((x) => x.organizationId?.[0]);
  const { data } = useGetTermsAndConditionsQuery(
    { organizationId: organizationId! },
    { skip: !organizationId },
  );
  const push = useNavigate();
  const backRoute = `/admin#${AdminTabKeys['terms-and-conditions']}`;

  const handleUpdate = useCallback(
    async (value: UpdateTermsAndConditionsArgs) => {
      await update(value).unwrap();
      push(-1);
    },
    [update, push],
  );

  const latest = data?.[0];

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/admin#terms-and-conditions">
          {t('termsAndConditions.title')}
        </Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="edit" />}
          color="#814A93"
          actions={
            <Space size="middle">
              <Button onClick={() => push(backRoute)}>{t('cancel')}</Button>
              <Form.Submit uid="terms-and-conditions" type="primary">
                {t('termsAndConditions.save')}
              </Form.Submit>
            </Space>
          }
        >
          <TermsAndConditionsEditPanel
            onSubmit={handleUpdate}
            initialValue={
              latest
                ? { content: latest.content, version: latest.version + 1 }
                : undefined
            }
          />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
